import React from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {CommunityGetSchema} from '../../../../api/DBSchema/Community';
import {dateAndTimeToString} from '../../../../utils/utils';

const pageSchema = CommunityGetSchema;

function CommunityHistory({
    communityObject,
}) {
    const { t } = useTranslation();

    const pageData = communityObject;

    const createTime = pageData[pageSchema.createTime];
    const lastTime   = pageData[pageSchema.lastTime];

    return (
        <EditorLayout>
            <SMCTextInput
                readOnly
                value={dateAndTimeToString(createTime, true)}
                label={t('SMC_GEN_STATS_CREATETIME')}
            />
            <SMCTextInput
                readOnly
                value={dateAndTimeToString(lastTime, true)}
                label={t('SMC_GEN_STATS_LASTMOD')}
            />
        </EditorLayout>
    )
}

export default CommunityHistory;